import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, Avatar, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import fotoPerfilDefault from "../../images/user.png";

export const ModalSolicitudMensaje = ({ onClose, open = true, user }) => {
	const apiUrl = process.env.REACT_APP_API_URL;
	const renderImage = (url) => {
		if (url !== null && url !== "") {
			return <Avatar src={`${apiUrl}${url}`} sx={{ width: 80, height: 80, mb: 1 }} />;
		}
		return <Avatar src={fotoPerfilDefault} alt="Usuario" sx={{ width: 80, height: 80, mb: 1 }} />;
	};
	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{ m: 0, p: 2 }}>
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>

			<DialogContent>
				<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
					{renderImage(user.profile_url)}
					<Typography variant="h6">{user.fullName}</Typography>
				</Box>

				<Box sx={{ backgroundColor: "#f5f5f5", p: 2, borderRadius: 2 }}>
					{user.user_message === "ninguno" ? (
						<Typography sx={{ fontStyle: "italic", color: "text.secondary" }}>
							No existe mensaje de solicitud
						</Typography>
					) : (
						<Typography>{user.user_message}</Typography>
					)}
				</Box>
			</DialogContent>
		</Dialog>
	);
};
